<template>
  <div class="bg">
    <div class="tabsStyle">
      <el-tabs v-model="searchForm.state" @tab-click="tabsClick">
        <el-tab-pane
          v-for="item in voucherStateData"
          :label="item.label"
          :name="item.value"
          :key="item.label"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content">
      <div class="content_l">
        <div class="col" style="flex: 1">
          <div class="lable">代金劵类型</div>
          <div class="input">
            <el-select
              v-model="searchForm.type"
              style="width: 100%"
              placeholder="请选择代金劵类型"
              @keyup.enter.native="onSubmit"
              clearable
            >
              <el-option
                v-for="item in voucherTypeData.slice(1)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col">
          <div class="lable">代金劵来源</div>
          <div class="input">
            <el-select
              v-model="searchForm.source"
              style="width: 100%"
              placeholder="请选择代金劵来源"
              @keyup.enter.native="onSubmit"
              clearable
            >
              <el-option
                v-for="item in voucherSourceData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col">
          <div class="lable">截止日期</div>
          <div class="input">
            <el-date-picker
              v-model="validUntil"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="solid"></div>
      <div class="content_r">
        <el-button @click="onSubmit" class="btn1" type="primary"> 查询 </el-button>
        <div class="btn2" @click="onClear">重置筛选</div>
      </div>
    </div>
  </div>
</template>

<script>
import selectData from "@/mixins/selectData.js";

import userinfo from "@/mixins/userinfo.js";
export default {
  mixins: [userinfo, selectData],
  props: {
    searchForm: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      accountColleagueList: [],
    };
  },
  computed: {
    validUntil: {
      get() {
        const { validUntilStart, validUntilEnd } = this.searchForm;
        if (validUntilStart && validUntilEnd) {
          return [validUntilStart, validUntilEnd];
        }
        return null;
      },
      set(value) {
        this.$emit("update:searchForm", {
          ...this.searchForm,
          validUntilStart: value ? value[0] : null,
          validUntilEnd: value ? value[1] : null,
        });
      },
    },
  },
  mounted() {
    this.getAccountColleagueList();
  },
  methods: {
    choose(res) {
      this.$emit("update:searchForm", {
        ...this.searchForm,
        state: res.value,
      });
    },
    onSubmit() {
      this.$emit("submit");
    },
    onClear() {
      this.$emit("onClear");
    },
    async getAccountColleagueList() {
      // 获取消费账号
      const { status, data } = await this.$api.getAccountColleagueList();
      if (status === 200) {
        this.accountColleagueList = data;
      }
    },
    tabsClick() {
      console.log("321");
      this.$emit("tabsClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  background: #fff;
  border-radius: 6px;

  .tabsStyle {
    @include tabsStyle;
  }
  .content {
    display: flex;
    padding: 16px 0;
    align-items: center;
    &_l {
      display: grid;
      grid-template-columns: repeat(3, 1fr); /* 3列 */
      grid-template-rows: repeat(2, auto); /* 2行 */
      row-gap: 14px; /* 设置行间距为 14px */
      flex: 1;
      .col {
        display: flex;
        height: 34px;
        align-items: center;
        .lable {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: normal;
          line-height: normal;
          letter-spacing: 0px;

          font-variation-settings: "opsz" auto;
          color: #262626;
          width: 100px;
          text-align: end;
          padding: 0 12px;
        }

        .input {
          &::v-deep {
            @include inputStyle;
          }
          flex: 1;
        }
      }
    }
    .solid {
      width: 1px;
      height: 60px;
      background: #eeeeee;
      margin-left: 18px;
    }
    &_r {
      width: 132px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .btn1 {
        @include buttonStyle;
      }
      .btn2 {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #0062ff;
        margin-top: 14px;
        height: 34px;
        line-height: 34px;
        cursor: pointer;
      }
    }
  }
}
</style>
